import types from '../types'
import Action from '../../types/Action'

const initialState: { providerDetails: any; updateDetail: any; providerDetailToUpdate: any } = {
  providerDetails: {
	  loading: true,
    success: false,
    error: false,
    data: []
  },
  updateDetail: {
	  loading: true,
    success: false,
    error: false,
    data: []
  },
  providerDetailToUpdate: {
	  loading: true,
    success: false,
    error: false,
    data: []
  }
}

const providerDetailReducer = (state = initialState, action: Action) => {
  switch (action.type) {
	  case types.GET_PROVIDER_DETAIL_REQUESTED: {
      return {
        ...state,
        providerDetails: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_PROVIDER_DETAIL_FULFILLED: {
      return {
        ...state,
        providerDetails: {
		    ...state.providerDetails,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_PROVIDER_DETAIL_REJECTED: {
      return {
        ...state,
        providerDetails: {
		      ...state.providerDetails,
          loading: false,
          error: action.payload
        }
      }
    }
	  case types.GET_ORG_PROVIDER_DETAIL_REQUESTED: {
      return {
        ...state,
        providerDetails: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_ORG_PROVIDER_DETAIL_FULFILLED: {
      return {
        ...state,
        providerDetails: {
		      ...state.providerDetails,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_ORG_PROVIDER_DETAIL_REJECTED: {
      return {
        ...state,
        providerDetails: {
		      ...state.providerDetails,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_DETAIL_REQUESTED: {
      return {
        ...state,
        updateDetail: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_DETAIL_FULFILLED: {
      const index = state.providerDetails.data.findIndex((detail: any) => detail.providerId === action.payload.providerId)
      return {
        ...state,
        updateDetail: {
		      ...state.updateDetail,
          loading: false,
          success: true,
          data: action.payload
        },
        providerDetails: {
          ...state.providerDetails,
          data: [
            ...state.providerDetails.data.slice(0, index),
            action.payload,
            ...state.providerDetails.data.slice(index + 1)
          ]
        }
      }
    }
	  case types.UPDATE_PROVIDER_DETAIL_REJECTED: {
      return {
        ...state,
        updateDetail: {
		      ...state.updateDetail,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.GET_DETAIL_TO_UPDATE_REQUESTED: {
      return {
        ...state,
        providerDetailToUpdate: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_DETAIL_TO_UPDATE_FULFILLED: {
      return {
        ...state,
        providerDetailToUpdate: {
          ...state.providerDetailToUpdate,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_DETAIL_TO_UPDATE_REJECTED: {
      return {
        ...state,
        providerDetailToUpdate: {
          ...state.providerDetailToUpdate,
          loading: false,
          error: action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}

export default providerDetailReducer